import { Outlet } from 'react-router-dom';

import { CookieBanner } from '@/components/marketing/CookieBanner';

import { MarketingFooter } from './MarketingFooter';
import { MarketingNav } from './MarketingNav';

export function MarketingLayout() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--paper)' }}>
      <MarketingNav />
      <div style={{ flex: 1 }}>
        <Outlet />
      </div>
      <MarketingFooter />
      <CookieBanner />
    </div>
  );
}
